<template>
  <div v-show="this.$store.state.user.wheelOpen " class="popup-frame" :class="{ 'active': this.$store.state.user.wheelOpen }">
    <div id="roulette_popup" class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable">
      <transition name="fade">
        <div v-show="!prizeShow" class="popup-package">
          <button class="btn-close" @click="closeModal" />
          <div class="popup-content bg-transparent">
            <div class="popup-body spinTheWheel-bg">
              <div class="spinTheWheel-img">
                <div class="spinTheWheel">
                  <div class="wheel-box">
                    <div
                      v-if="!prizeResult"
                      class="title mt-3"
                      :class="{ 'animate__animated_fast': !canvasVerify && !prizeResult }"
                    >
                      ラッキースピン
                    </div>
                    <!-- <div v-if="prizeResult" class="title mt-3  animate__animated animate__slow animate__infinite animate__flash">
                      YOU WIN
                    </div> -->
                    <!-- <div style="height:40px">
                      <div v-if="prizeResult" class="bonusAward">
                        <span class="b-number">¥{{ prizeResult }}</span>
                        <span class="b-shadow">¥{{ prizeResult }}</span>
                      </div>
                    </div> -->
                    <div class="theWheel">
                      <!-- type: canvas -->
                      <FortuneWheel
                        v-if="prizesWithEqualDivisions.length > 0"
                        ref="fortuneWheelButton"
                        :canvas="canvasOptions1"
                        :prizes="prizesWithEqualDivisions"
                        :verify="canvasVerify"
                        :disabled="prizeShow "
                        :duration="duration"
                        :angle-base="angleBase"
                        @rotateStart="onCanvasRotateStart"
                        @rotateEnd="onRotateEnd"
                      />
                    </div>
                  </div>
                </div>
                <div class="spinWheel-btn-package">
                  <div
                    style="height:40px"
                  >
                    <!-- <button v-if="prizeResult" class=" btn-spinWheel-confirm" @click="confirm">
                      Confirmation
                    </button> -->
                    <div v-if="$store.getters.token && !prizeResult && canvasVerify" class="lastTimes-title">
                      <!-- eslint-disable-next-line -->
                    <span class="shop_span"  v-html="shopRedeemText" />
                    </div>
                  </div>

                  <!-- <div
                    style="height:20px"
                  >
                    <div v-if="$store.getters.token && formattedCountdown && !prizeResult && canvasVerify" class="lastTimes-title" style="padding-top:15px">
                      {{ $t("Bao.roulette_time") }} <span class="countdown-time">{{ formattedCountdown }}</span>
                    </div>
                  </div> -->
                  <div v-if="$store.getters.token && spinRemainCount" class="lastTimes-frame" style="padding-top:15px">
                    <span class="lastTimes-title"> {{ $t("Bao.roulette_total") }}</span>&nbsp;<span class="lastTimes">{{ spinRemainCount }}</span>/{{ spinTotal }}
                  </div>
                  <div v-if="$store.getters.token && !spinRemainCount" class="lastTimes-frame" style="padding-top:15px">
                    <span class="lastTimes-title"> {{ $t("Bao.roulette_total") }}</span>&nbsp;<span class="lastTimes">0</span>/{{ spinTotal }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <prize-modal :prize="prizeResult" :show="prizeShow" @prize-confirmed="confirm" @close="closeModal" />
    </div>
  </div>
</template>
<script>
import FortuneWheel from 'vue-fortune-wheel'
import PrizeModal from '@/components/modal/prizeModal'
import 'vue-fortune-wheel/lib/vue-fortune-wheel.css'
import { showNotice } from '@/utils/tool'
import { getEventDetail, joinEventV3 } from '@/api/event'
export default {
  components: {
    FortuneWheel,
    PrizeModal
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCount: false,
      spinInterval: 0,
      prizeResult: null,
      prizeShow: false,
      finalPrize: null,
      spinTotal: null,
      lastTriggerTime: null,
      rewardInfo: null,
      showPrizeModal: false,
      isRequestInProgress: false,
      // Data for First FortuneWheel
      canvasOptions1: {
        borderWidth: 6,
        borderColor: 'transparent',
        btnWidth: 100,
        btnText: '',
        fontSize: 24,
        textDirection: 'horizontal',
        textLength: 4,
        lineHeight: 34,
        textRadius: 205
      },
      prizesWithEqualDivisions: [],
      canvasVerify: true,
      duration: 5000,
      angleBase: 3
    }
  },
  computed: {
    shopRedeemText() {
      if (this.prizesWithEqualDivisions.length > 0) {
        return this.$t('Bao.shop_redeem', {
          points: `<span class="clickable-shop">${this.prizesWithEqualDivisions[0].condition_value_4}</span>`
        })
      }
      return ''
    },

    mainPoint() {
      const storeMainPoint = this.$store.getters.mainPoint
      if (!isNaN(storeMainPoint)) {
        return storeMainPoint
      } else {
        return this.$store.state.user.memberInfo.main_points
      }
    },
    formattedCountdown() {
      const countdownValue = this.$store.state.user.wheelCountdown
      if (countdownValue && countdownValue >= 0) {
        const minutes = Math.floor(countdownValue / 60)
        const seconds = countdownValue % 60
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      }
      return ''
    },
    spinRemainCount() {
      if (this.rewardInfo) {
        return this.spinTotal - this.rewardInfo.today_reward_count
      } return ''
    }
  },
  watch: {
    '$store.getters.token'(newVal, oldVal) {
      if (newVal) {
        if (this.$store.state.user.lotteryId) {
          getEventDetail(this.$store.state.user.lotteryId)
            .then(response => {
              this.rewardInfo = response.data.data.reward
              const prizesFromAPI = response.data.data.setting.prize
              const wheelLayout = response.data.data.setting.layout
              // this.spinInterval = response.data.data.setting.lottery_time_range
              this.spinTotal = response.data.data.setting.lottery_count_limit

              if (this.$store.state.user.wheelCountdown > 0) {
                this.showCount = true
                // const currentTime = Math.floor(Date.now() / 1000)
                // const lastRewardAt = this.rewardInfo.last_reward_at
                // const timeDifference = currentTime - lastRewardAt
                // const initialCountdown = this.spinInterval - timeDifference
                // this.$store.commit('SET_WHEEL_TIME', initialCountdown)
                // this.countDown()
              }
              // Create a Map to store unique objects and their duplicate counts
              const uniquePrizes = new Map()
              // Map duplicates with special characters
              const updatedPrizes = wheelLayout.map(prizeId => {
                const prize = prizesFromAPI.find(item => item.id === prizeId) // Find prize object from prizesFromAPI
                const duplicateCount = uniquePrizes.get(prizeId) || 0
                uniquePrizes.set(prizeId, duplicateCount + 1)
                return {
                  ...prizeId,
                  name: prize.name,
                  amount: prize.prize,
                  condition_value_4: prize.condition_value_4,
                  id: duplicateCount === 0 ? prizeId : parseInt(`${prizeId}_${duplicateCount}`)
                }
              })

              updatedPrizes[0].probability = 100
              updatedPrizes.forEach((prize, index) => {
                if (index % 2 === 0) {
                // Even index
                  prize.bgColor = '#B1A781' // Purple gradient
                  prize.color = '#FFFFFF' // White text color for contrast
                } else {
                // Odd index
                  prize.bgColor = '#fff' // Yellow gradient
                  prize.color = '#000000' // Black text color
                }
              })
              this.prizesWithEqualDivisions = updatedPrizes
            })
            .catch(error => {
              console.error('Error fetching prizes from API:', error)
            })
        }
      }
    },
    '$store.state.user.wheelOpen'(newVal, oldVal) {
      if (newVal) {
        this.disableScrolling()
        // if (!this.spinRemainCount || this.formattedCountdown) {
        //   this.unableToSpin()
        // } else {
        //   this.ableToSpin()
        // }
      } else {
        this.enableScrolling()
      }
    },
    '$store.state.user.lotteryId'(newVal) {
      if (newVal) {
        getEventDetail(newVal)
          .then(response => {
            this.rewardInfo = response.data.data.reward
            const prizesFromAPI = response.data.data.setting.prize
            const wheelLayout = response.data.data.setting.layout
            // this.spinInterval = response.data.data.setting.lottery_time_range
            this.spinTotal = response.data.data.setting.lottery_count_limit

            if (this.$store.state.user.wheelCountdown > 0) {
              this.showCount = true
              // const currentTime = Math.floor(Date.now() / 1000)
              // const lastRewardAt = this.rewardInfo.last_reward_at
              // const timeDifference = currentTime - lastRewardAt
              // const initialCountdown = this.spinInterval - timeDifference
              // this.$store.commit('SET_WHEEL_TIME', initialCountdown)
              // this.countDown()
            }
            // Create a Map to store unique objects and their duplicate counts
            const uniquePrizes = new Map()
            // Map duplicates with special characters
            const updatedPrizes = wheelLayout.map(prizeId => {
              const prize = prizesFromAPI.find(item => item.id === prizeId) // Find prize object from prizesFromAPI
              const duplicateCount = uniquePrizes.get(prizeId) || 0
              uniquePrizes.set(prizeId, duplicateCount + 1)
              return {
                ...prizeId,
                name: prize.name,
                amount: prize.prize,
                condition_value_4: prize.condition_value_4,
                id: duplicateCount === 0 ? prizeId : parseInt(`${prizeId}_${duplicateCount}`)
              }
            })

            updatedPrizes[0].probability = 100
            updatedPrizes.forEach((prize, index) => {
              if (index % 2 === 0) {
                // Even index
                prize.bgColor = '#B1A781'
                prize.color = '#FFFFFF'
              } else {
                // Odd index
                prize.bgColor = '#fff'
                prize.color = '#000000'
              }
            })
            this.prizesWithEqualDivisions = updatedPrizes
          })
          .catch(error => {
            console.error('Error fetching prizes from API:', error)
          })
      }
    },
    finalPrize(newVal) {
      if (newVal) {
        let firstMatchFound = false
        this.prizesWithEqualDivisions = this.prizesWithEqualDivisions.map(prize => {
          if (prize.id === newVal && !firstMatchFound) {
            firstMatchFound = true
            return { ...prize, probability: 100 }
          } else {
            return { ...prize, probability: 0 }
          }
        })
      }
    }
  },
  created() {
    if (this.$store.state.user.lotteryId) {
      getEventDetail(this.$store.state.user.lotteryId)
        .then(response => {
          if (response.data.data.reward.length === 0) {
            response.data.data.reward = ''
          }
          this.rewardInfo = response.data.data.reward
          const prizesFromAPI = response.data.data.setting.prize
          const wheelLayout = response.data.data.setting.layout
          // this.spinInterval = 30
          this.spinTotal = response.data.data.setting.lottery_count_limit

          if (this.$store.state.user.wheelCountdown >= 0) {
            this.showCount = true

            // const currentTime = Math.floor(Date.now() / 1000) // Get current time in seconds
            // const lastRewardAt = this.rewardInfo.last_reward_at
            // const timeDifference = currentTime - lastRewardAt
            // const initialCountdown = this.spinInterval - timeDifference

            // this.$store.commit('SET_WHEEL_TIME', initialCountdown)
            // this.countDown()
          }
          // Create a Map to store unique objects and their duplicate counts
          const uniquePrizes = new Map()
          // Map duplicates with special characters
          const updatedPrizes = wheelLayout.map(prizeId => {
            const prize = prizesFromAPI.find(item => item.id === prizeId) // Find prize object from prizesFromAPI
            const duplicateCount = uniquePrizes.get(prizeId) || 0
            uniquePrizes.set(prizeId, duplicateCount + 1)
            return {
              ...prizeId,
              name: prize.name,
              amount: prize.prize,
              condition_value_4: prize.condition_value_4, // 扣除積分
              id: duplicateCount === 0 ? prizeId : parseInt(`${prizeId}_${duplicateCount}`)
            }
          })

          updatedPrizes[0].probability = 100
          updatedPrizes.forEach((prize, index) => {
            if (index % 2 === 0) {
              // Even index
              prize.bgColor = '#B1A781'
              prize.color = '#FFFFFF'
            } else {
              // Odd index
              prize.bgColor = '#fff'
              prize.color = '#000000'
            }
          })
          if (this.$store.state.user.wheelOpen) {
            this.disableScrolling()
          }
          this.prizesWithEqualDivisions = updatedPrizes
        })
        .catch(error => {
          console.error('Error fetching prizes from API:', error)
        })
    }
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     const countdownValue = this.$store.state.user.wheelCountdown
  //     setTimeout(() => {
  //       if (countdownValue > 0 && this.$refs.fortuneWheelButton) {
  //         this.unableToSpin()
  //       }
  //     }, 500)
  //   })
  // },
  methods: {
    confirm() {
      this.prizeResult = ''
      this.prizeShow = false
      this.$store.commit('SET_WHEEL_OPEN', true)
      // if (this.$route.path !== '/points/roulette-bonus') {
      //   this.$router.push('/points/roulette-bonus')
      // }
      // if (!this.$store.state.user.wheelCountdown) {
      //   this.ableToSpin()
      // }
    },
    closeModal() {
      if (!this.canvasVerify) {
        return
      }
      this.prizeResult = ''
      this.prizeShow = false
      this.$store.commit('SET_WHEEL_OPEN', false)
    },

    unableToSpin() {
      // const button = this.$refs.fortuneWheelButton
      // if (button) {
      //   button.$el.querySelector('.fw-btn__btn').classList.add('hide-before')
      // }
    },
    ableToSpin() {
      // const button = this.$refs.fortuneWheelButton
      // if (button) {
      //   button.$el.querySelector('.fw-btn__btn').classList.remove('hide-before')
      // }
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.$store.state.user.wheelCountdown > 0) {
          this.showCount = true
          this.$store.commit('SET_WHEEL_TIME', this.$store.state.user.wheelCountdown - 1)
        } else {
          this.showCount = false
          this.canvasVerify = true
          clearInterval(timer)
          // if (!this.prizeResult) {
          //   this.ableToSpin()
          // }
        }
      }, 1000)
    },
    onCanvasRotateStart(rotate) {
      if (!this.$store.getters.token) {
        this.$store.commit('SET_LOGIN_OPEN', true)
        this.$store.commit('SET_WHEEL_OPEN', false)
      } else {
        const maxConditionValue = Math.max(... this.prizesWithEqualDivisions.map(prize => prize.condition_value_4))
        if (this.mainPoint < maxConditionValue) {
          this.canvasVerify = false
          this.prizeShow = false
          this.$store.commit('SET_WHEEL_OPEN', false)
          showNotice(this.$t('Bao.point_lack'))
        }
        // const currentTime = new Date().getTime() // Get the current time in milliseconds

        // Check if the function is being called within the last 2 seconds

        // Update the last trigger time immediately
        // this.lastTriggerTime = currentTime

        // If it's been more than 2 seconds since the last trigger, proceed with the function logic
        if (this.canvasVerify && !this.isRequestInProgress) {
          this.isRequestInProgress = true // Set the flag to true
          joinEventV3(this.$store.state.user.lotteryId)
            .then(response => {
              this.finalPrize = response.data.data.prize.id
              return this.DoServiceVerify(this.canvasVerify, 100)
            })
            .then(verifiedRes => {
              if (verifiedRes) {
                // this.unableToSpin()
                rotate() // Call the callback, start spinning
                this.canvasVerify = false
                // this.$store.commit('SET_WHEEL_TIME', this.spinInterval)
                // const lastTrigger = Math.floor(Date.now() / 1000) // Get the current time in seconds
                // this.$store.commit('SET_LAST_TRIGGER_TIME', lastTrigger) // Store the last trigger time in the Vuex store
              } else {
                this.prizeResult = ''
                this.prizeShow = false
                this.$store.commit('SET_WHEEL_OPEN', false)
                showNotice('No ID match the prize result')
              }
            })
            .catch(error => {
              showNotice(error)
              this.prizeResult = ''
              this.prizeShow = false
              this.$store.commit('SET_WHEEL_OPEN', false)
            })
            .finally(() => {
              this.isRequestInProgress = false // Reset the flag after the request completes
            })
        }
      }
    },
    disableScrolling() {
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
      document.body.style.overflow = ''
    },
    // handleShopClick(event) {
    //   if (event.target.classList.contains('clickable-shop')) {
    //     this.$store.commit('SET_WHEEL_OPEN', false)
    //     if (this.$route.path !== '/points/roulette-bonus') {
    //       this.$router.push('/points/roulette-bonus')
    //     }
    //   }
    // },
    onRotateEnd(prize) {
      this.showCount = true
      this.lastTriggerTime = null
      this.prizeResult = prize.name
      this.prizeShow = true
      this.canvasVerify = true // Reset canvasVerify to true
      getEventDetail(this.$store.state.user.lotteryId)
        .then(response => {
          this.spinTotal = response.data.data.setting.lottery_count_limit
          this.rewardInfo = response.data.data.reward
        })
        .catch(error => {
          console.error('Error fetching prizes from API:', error)
        })
      // this.countDown()
    },
    // Simulate the request back-end interface, verified: whether to pass the verification, duration: delay time
    DoServiceVerify(verified, duration) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(verified)
        }, duration)
      })
    }
  }
}
</script>
<style>
/* @import url('https://fonts.googleapis.com/css2?family=Fugaz+One&display=swap'); */

.shop_span {
  font-size: 14px;
}
.clickable-shop {
  cursor: pointer;
  color: #df0d0d;
}
.popup-frame {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 200;
  transition: all 0.35s;
  background: rgba(0, 0, 0, 0.65);
  opacity: 0;
}

.popup-frame .btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  position: absolute;
  padding: 0.45rem;
  top: -32px;
  right: -10px;
  z-index: 99;
  border: black;
  border-radius: 50%;
  background:rgba(255, 255, 255, 0.75) url(../../assets/theme_gold/images/icon-close-black.png) center / 1em auto no-repeat;
}

#roulette_popup .popup-frame .btn-close {
  right: -18px;
}

.popup-package {
  display: flex;
  position: relative;
  max-height: 90dvh;
  /* margin-bottom: -40px; */
  z-index: 2024;
}
#roulette_popup.popup-package {
  max-width: 450px;
}

.popup-container {
  position: relative;
  margin: 0 auto;
  width: 80%;
  /* max-width: 500px; */
  height: 100%;
}

.popup-frame.active {
  opacity: 1;
  transition: all 0.35s;
}

.popup-content {
  width: 100%;
  max-height: 100%;
  overflow: hidden;
  background-color: #fff;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.popup-body {
  overflow-y: auto;
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.popup-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
}

.popup-dialog-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100% - 1rem);
}

.spinTheWheel-bg {
  width: 80dvw;
  max-width: 420px;
  background: linear-gradient(115deg, rgba(255, 255, 255, 0.025) 0%, rgba(0, 0, 0, 0.65) 10%, rgba(255, 255, 255, 0.025) 50%, rgba(0, 0, 0, 0.35) 50.1%, rgba(0, 0, 0, 0.55) 75%, rgba(255, 255, 255, 0.045) 100%);
  background-position: left top, right 5px top 10px;
  background-repeat: no-repeat;
  transition: all 0.15s;
  /* 2 */
}
.bg-transparent {
  background-color: transparent;
}
.spinTheWheel-img {
  background-image: url(../../assets/theme_gold/images/spin_wheel_bg_lt.png), url(../../assets/theme_gold/images/spin_wheel_bg_rt.png);
  background-size: 20%, 20%;
  background-position: left 2px top -2px, right 2px top -1px;
  background-repeat: no-repeat;
}

.spinTheWheel {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 418px;
}

.wheel-box {
  display: flex;
  flex-flow: column wrap;
  row-gap: .5rem;
  padding-top: 1rem;
}

.spinTheWheel .title {
  margin: 0 auto;
  color: #FFF;
  text-shadow: 3px 1px rgb(40 10 0 / 75%), 3px 2px 10px rgb(255 0 0 / 70%);
  font-family: "Fugaz One", sans-serif, 微软雅黑, Arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 2rem;
  font-weight: bold;
  line-height: normal;
}

.bonusAward {
  display: flex;
  position: relative;
  min-height: 2.5rem;
}

.b-number,
.b-shadow {
  left: 50%;
  transform: translateX(calc(-50% - 2px));
  position: absolute;
  font-size: 3rem;
  font-weight: bold;
  font-family: "Fugaz One", sans-serif, 微软雅黑, Arial, sans-serif;
  line-height: 1;
  letter-spacing: 3px;
}

.b-number {
  z-index: 1;
  background-image: linear-gradient(356deg, #fbe878 36.93%, #d2b719 77.3%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.b-shadow {
  transform: translateX(calc(-50% + 1px));
  background-image: linear-gradient(356deg, #543502 23.24%, #9d6407 49.85%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.fw-container {
  max-width: 520px;
  width: 100%;
}
/* .fw-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  } */
.theWheel {
  background-image: url(../../assets/theme_gold/images/wheel_2x.png);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: contain;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 2.4%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vh;
}

.fw-btn__btn {
  cursor: pointer;

  background: radial-gradient(closest-corner, #B1A781 60%, #414138 100%) !important;
  border: 4px solid #fff !important;
  font-size: 24px !important;
}
.fw-btn__btn:after {
  content:"";
  display: block;
  width: 0;
  height: 0;
  bottom: 85% !important;
  border-bottom: 20px #B1A781 solid !important;
  border-left: 12px solid transparent !important;
  border-right: 12px solid transparent !important;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.fw-btn__btn:before {
  content: "SPIN" !important;
  display: block;
  width: 0;
  height: 0;
  border-left: 1px solid transparent !important;
  border-right: 1px solid transparent !important;
  border-bottom: 1px solid !important;
  position: absolute;
  bottom: 70% !important;
  left: 18% !important;
  animation-name: flash;
  animation-duration: calc(1s * 2);
  animation-iteration-count: infinite;
  z-index: 10;
}
.hide-before::before {
  content: "SPIN";
  animation-iteration-count: 0;
  color: #8C0000;
  text-shadow: 1px 1px 1px rgb(255 47 0), -1px -1px 1px #2B0000 !important;
}

.theWheelPic {
  width: 100%;
  height: auto;
}

.spinWheel-btn-package {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  gap: auto;
}

.btn-spinWheel {
  color: #df0d0d;
  text-shadow: 1px 1px 0px rgb(255, 255, 255), 3px 3px 0px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  font-size: 1.65rem;
  background-color: transparent;
  border: none;
}

.btn-spinWheel-confirm {
  width: 100%;
  max-width: 200px;
  color: #fff;
  text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.4);
  font-size: 21px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  padding: .5rem 1rem;
  border-radius: 36px;
  background: linear-gradient(
    0deg,
    rgba(125, 79, 5, 1) 0%,
    rgba(244, 196, 54, 1) 47%,
    rgba(249, 215, 150, 1) 87%
  );
  filter: drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.3));
  border: none;
  transition: all 0.35s;
}

.btn-spinWheel-confirm:focus,
.btn-spinWheel-confirm:hover {
  color: rgba(125, 79, 5, 1);
  text-shadow: 0px 0px 0px rgba(255, 255, 255, 0.8);
  box-shadow: inset 5px 8px 5px rgba(125, 79, 5, 1), 0 0 1px 2px rgba(255, 255, 255, 0.45);
  background: rgba(244, 196, 54, 1);
  transition: all 0.35s;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.35));
}

button.btn-spinWheel-confirm:disabled,
button.btn-spinWheel-confirm[disabled] {
  background: #d2d0c9 !important;
  filter: none;
  color: #888;
  text-shadow: none;
}

button.btn-spinWheel-confirm:disabled:hover {
  box-shadow: inset 0px 0px 25px rgba(0, 0, 0, 0.35), 0 0 1px 2px rgba(255, 255, 255, 0.45);
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.35));
}

.countdown-title {
  color: #4f2f09;
  text-shadow: none;
  font-size: 22px;
}

.countdown-time {
  color: #df0d0d;
}

.lastTimes-frame {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  color: #df0d0d;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
}

.lastTimes-title {
  color: #7c7c7c;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.animate__animated.animate__infinite {
  animation-iteration-count: infinite;
}

.animate__animated.animate__slow {
  animation-duration: calc(1s * 2);
}
.animate__flash {
  animation-name: flash;
  }
.animate__animated_fast {
  animation-iteration-count: infinite;
  animation-name: flash;
  animation-duration: calc(1s * 0.8);
}
.fade-enter-active, .fade-leave-active {
  transition: scale 0.5s;
}
.fade-enter, .fade-leave-to {
  scale: 0;
}
    /* min-width */
@media (min-width: 576px) {
  .popup-dialog {
    padding-left: 40px;
    margin: 3rem auto;
  }
  #roulette_popup .popup-dialog {
    max-width: 500px;
  }

  .popup-dialog-scrollable {
    height: calc(100% - 7rem);
  }

  .popup-dialog-centered {
    min-height: calc(100% - 6rem);
  }

  .popup-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .popup-lg,
  .popup-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .popup-xl {
    max-width: 1140px;
  }
}

@media (max-width: 1199.98px) {
  .spinTheWheel-bg {
    max-height: calc(100dvh - 80px);
  }
}

.iframe-full-screen {
  width: 93dvw;
  height: 100dvh;
  height: 100vh;
  height: auto;
}
.iframe-full-screen .popup-body {
  padding: 0;
}

/* max-width */
@media (max-width: 992px) {
  .btn-close {
    right: 0;
  }
}
@media (max-width: 575.98px) {
  .shop_span {
    font-size: 12px;
  }

  .fw-btn__btn {
        font-size: 22px !important;
    width: 80px !important;
    height: 80px !important;
    border: 4px solid #fff !important;
  }
  .fw-btn__btn:after {
    border-left: 11px solid transparent !important;
    border-right: 11px solid transparent !important;
  }
  .fw-btn__btn:before {
    bottom: 73% !important;
    left: 11% !important;
  }
  .b-number,.b-shadow {
    font-size: 2.5rem;
    }
  .lastTimes-frame, .countdown-title {
    font-size: 14px;
  }
  .spinTheWheel .title{
    font-size: 32px;
  }
  .btn-spinWheel-confirm {
    font-size: 22px;
  }
}

@media (max-width: 375px) {
  .fw-btn__btn {
    width: 70px !important;
    height: 70px !important;
  }

  .fw-btn__btn:before {
    bottom: 70% !important;
    left: 20% !important;
    font-size: 1rem;
  }
}

@-webkit-keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
  opacity: 0;
  }
}

@keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

</style>
